import * as React from 'react';
import styled from 'styled-components';

type Props = {
  topOffset?: number;
};

const Container = styled.div<Props>`
  position: fixed;
  top: ${(props): number => props.topOffset || 0}px;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: auto;
`;

const FullPageContainer: React.FC<React.PropsWithChildren<Props>> = ({
  topOffset = 0,
  children,
}) => {
  return <Container topOffset={topOffset}>{children}</Container>;
};

export default FullPageContainer;
